const initialState = {
    dataTableList: []
}

const projectReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_PROJECT_TABLE':
            return {
                ...state,
                dataTableList: action.payload
            }
        default:
            return state
    }
}

export default projectReducer
